
import Vue from "vue";
import { Task } from "../../models/tasks/task";
import { TaskService } from "../../services/task-service";
import AppTaskItem from "./TaskItemStatic.vue";

export default Vue.extend({
	data() {
		return {
			openedTask: null as null | Task
		};
	},
	props: {
		tasks: {
			type: Array as () => Task[],
			required: true
		}
	},
	methods: {
		async openTask(task:Task) {
			this.openedTask = await TaskService.getTask(task.ID);
		}
	},
	components: {
		AppTaskItem
	},
	i18nEx: {
		componentPrefix: "components.tasks"
	}
});
